export default __webpack_public_path__ + "static/media/mobile-photo-9.623125f2.jpg";